import $ from 'jquery'

const padLeft = (nr, n, str) => Array(n - String(nr).length + 1).join(str || '0') + nr

const bgRandom = () => {
  const $target = $('[data-random-class]')

  if (!$target.length) {
    return
  }

  $target.each((index, el) => {
    const $this = $(el)
    const className = $this.data('random-class')
    const max = $this.data('random-max')

    if (!max) {
      return
    }

    const number = Math.floor(Math.random() * max + 1)
    $this.addClass(className.replace('{num}', padLeft(number, 2)))
  })
}

export default bgRandom
